require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/product/cross_sell.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/product/cross_sell.legacy.js
// module id = 644
// module chunks = 31